<template>
  <v-container>
    <div>
      <div
        v-if="loading"
        class="text-center"
        :style="styleObject"
      >
        <v-icon
          light
          class="custom-loader"
          :style="styleObject"
        >
          mdi-cached
        </v-icon>
        Carregando dados...
      </div>
      <div
        v-else-if="error"
        class="alert alert-danger"
      >
        {{ error }}
      </div>
      <div
        v-else
      >
        <v-row>
          <div class="border">
            <h4
              id="titulo"
              class="text-center"
            >
              1° SEMANA
            </h4><br>
            <span id="valorFatSemanal">
              VALOR FATU. <div
                id="valorFatId"
                class="text-right"
                :style="styleFaturamento"
              >{{ valorFatSemana1 }}</div>
            </span>
          </div>
          <div class="border">
            <h4
              id="titulo"
              class="text-center"
            >
              2° SEMANA
            </h4><br>
            <span id="valorFatSemanal">
              VALOR FATU. <div
                id="valorFatId"
                class="text-right"
                :style="styleFaturamento"
              >{{ valorFatSemana2 }}</div>
            </span>
          </div>
          <div class="border">
            <h4
              id="titulo"
              class="text-center"
            >
              3° SEMANA
            </h4><br>
            <span id="valorFatSemanal">
              VALOR FATU. <div
                id="valorFatId"
                class="text-right"
                :style="styleFaturamento"
              >{{ valorFatSemana3 }}</div>
            </span>
          </div>
          <div class="border">
            <h4
              id="titulo"
              class="text-center"
            >
              4° SEMANA
            </h4><br>
            <span id="valorFatSemanal">
              VALOR FATU. <div
                id="valorFatId"
                class="text-right"
                :style="styleFaturamento"
              >{{ valorFatSemana4 }}</div>
            </span>
          </div>
          <div class="border">
            <h4
              id="titulo"
              class="text-center"
            >
              5° SEMANA
            </h4><br>
            <span id="valorFatSemanal">
              VALOR FATU. <div
                id="valorFatId"
                class="text-right"
                :style="styleFaturamento"
              >{{ valorFatSemana5 }}</div>
            </span>
          </div>
        </v-row><br>
        <v-row no-gutters>
          <v-col>
            <v-sheet class="pa-2 ma-2" />
          </v-col>
          <v-col cols="2">
            <div id="alinharDireita">
              TOTAL FATU. <div
                id="valorFatId"
                class="text-right"
                :style="styleFaturamento"
              >
                {{ valorFaturamento }}
              </div>
            </div>
          </v-col>
        </v-row>
      </div>
    </div>
  </v-container>
</template>

<script>
  import Comercial from '../../../../../services/comercialpersonalizacao'
  import eventEmit from '../../core/EventoEmit'

  export default {
    name: 'ShowFaturamento',
    emits: [],
    components: {
    },
    data: () => ({
      styleObject: {
        color: localStorage.corPrimaria,
      },
      styleFaturamento: {
        color: '#C62828',
      },
      loading: false,
      error: null,
      dados: [],
      vendedores: [],
      selectMes: [],
      selectAno: [],
      valorFaturamento: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorFatSemana1: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorFatSemana2: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorFatSemana3: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorFatSemana4: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      valorFatSemana5: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
    }),

    created () {
      eventEmit.$on('update-dados-form', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-dados-form', this.handleUpdateDados)
    },

    methods: {
      handleUpdateDados (selectMes, selectAno, vendedores) {
        this.vendedores = vendedores
        this.selectMes = selectMes
        this.selectAno = selectAno

        this.valorFaturamento = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.valorFatSemana1 = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.valorFatSemana2 = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.valorFatSemana3 = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.valorFatSemana4 = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.valorFatSemana5 = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

        this.showFaturamento()
      },

      async showFaturamento () {
        this.loading = true

        await Comercial.showFaturamentoSemanal(this.selectMes, this.selectAno, this.vendedores, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            this.valorFatSemana1 = resposta.data.valorFat1.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            this.valorFatSemana2 = resposta.data.valorFat2.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            this.valorFatSemana3 = resposta.data.valorFat3.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            this.valorFatSemana4 = resposta.data.valorFat4.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            this.valorFatSemana5 = resposta.data.valorFat5.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            this.valorFaturamento = resposta.data.totalFaturado.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          } else if (resposta.data.text === 'Não há faturamento pelos filtros selecionados') {
            this.error = resposta.data.text

            this.showSnackbar('error', 3000, resposta.data.text)
          } else if (resposta.data.text === 'Empresa não encontrada') {
            this.error = resposta.data.text

            this.showSnackbar('error', 3000, resposta.data.text)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = 'Network Error'
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loading = false })
      },
    },
  }
</script>

<style scoped>
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 780px) {
    .border {
      width: 27rem;
      margin: 0 0 0 1rem
    }

    #alinharDireita {
      margin: 0rem 0rem 0 -22.5rem;
      width: 27rem;
    }
  }

  @media screen
  and (min-width: 1380px)
  and (max-width: 1901px) {
    .border {
      width: 16.5rem;
    }

    #alinharDireita {
      width: 16.5rem;
      margin: 0 0 0 -4rem;
    }
  }

  @media screen
  and (min-width: 1902px) {
    .border {
      width: 21rem;
    }

    #alinharDireita {
      width: 21rem;
      margin: 0 0 0 -6rem;
    }
  }
</style>

<style lang="sass">
  .border
    border: inset
    width: 14.9rem

  #titulo
    background: gray

  #alinharDireita
    background: gray
    width: 15rem
    margin: 0rem 0 0 -2rem

  #valorFatId
    margin: -1.6rem 1rem 0 0rem

</style>
